import { TranslateLoader } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { catchError, concatMap } from "rxjs/operators";
import { FileLogger } from "../core/error-handling/fileLogger";
import { ApiService } from "../shared/api/api.service";

enum I18nTarget {
  MOBILE = "mobile",
  DASHBOARD = "dashboard",
  GLORIA_CONFIGURATOR_DASHBOARD = "gloria-configurator-dashboard",
}

interface II18nTranslation {
  lang: string;
  target: I18nTarget;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  i18n: any;
}

export class CustomI18nTranslateLoader implements TranslateLoader {
  constructor(private apiService: ApiService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getTranslation(lang: string): Observable<any> {
    const i18nUrl = "i18nTranslation";
    const i18nParams = {
      target: I18nTarget.GLORIA_CONFIGURATOR_DASHBOARD,
      langs: lang,
    };
    const serverObservable = this.apiService.get(i18nUrl, i18nParams).pipe(
      catchError((error) => {
        FileLogger.error("CustomI18nTranslateLoader", "Server error while downloading translations", error);
        return of(null);
      }),
      concatMap((serverTrsl: II18nTranslation[]) => {
        if (!serverTrsl || serverTrsl.length < 1) {
          FileLogger.error("CustomI18nTranslateLoader", "Server sent back empty translations");
          return of({});
        } else {
          return of(serverTrsl[0].i18n);
        }
      })
    );

    return serverObservable;
  }
}
